const presence = {
  history: { title: 'Existing publications', body: 'Content and dates from your enterprise’s publication history. Open the original page to view it; nothing is republished.', publishedOn: 'Published {date}', recordedPages: 'recorded published URLs', receptionLoading: 'Loading reception settings…', receptionUnavailable: 'Reception settings could not be loaded. Your website content remains available below.' },
  page: { title: 'Presence', intro: 'See where your content is live and finish the tasks that need you.' },
  overview: { officialSite: 'Official site', searchSubmission: 'Search submission', needsAction: 'Needs your action', online: 'Online', submitted: 'Submitted' },
  queue: { title: 'Content task queue', all: 'All', needsAction: 'Needs action', inProgress: 'In progress', published: 'Published', taskCount: '{count} tasks' },
  state: { manualPrepared: 'Manual step prepared', reviewReady: 'Ready for review', processing: 'Processing', published: 'Published' },
  manual: { title: 'Complete this publication', noDuplicate: 'Nothing was posted twice.', fallbackBody: 'Automatic publishing did not complete, so a manual step is ready.', copy: 'Copy prepared content', openDestination: 'Open destination', publicUrl: 'Public URL after publishing', markPublished: 'Mark as published', saved: 'Saved as published.' },
  common: { websiteStatus: 'Website status', distribution: 'Distribution', details: 'Publication details', technicalRecord: 'View technical record', demoData: 'Demo data' },
  site: {
  "back": "All websites",
  "switchSite": "Switch website",
  "single": "The only website in this project",
  "navigation": "Website management",
  "manage": "Manage website",
  "manageAirlock": "Manage Airlock",
  "pageCount": "visitor-facing pages",
  "viewPages": "View pages",
  "todoCount": "{count} reception tasks need attention",
  "languageBody": "Website content languages follow the destination, not your interface language.",
  "pagesBody": "Pages and available reception formats in the current site version. Configure them in Airlock.",
  "noBuild": "No verified site version is available yet. Pages appear after a site build is verified.",
  "machinePages": "Machine-readable files",
  "readerPages": "Visitor pages",
  "machineNoSlot": "No reception UI",
  "noSlot": "No available placement yet",
  "originalTodo": "Back to this task",
  "todoUnavailable": "The original task is unavailable. Check this site’s current tasks.",
  "todoResolved": "This task has been resolved.",
  "todoOpen": "This task remains open. Submitting material does not resolve it automatically.",
  "domain": "Website address",
  "environmentLabel": "Environment",
  "installation": "Connection",
  "connected": "Automatic deployment connected",
  "guided": "Guided installation required",
  "connectedBody": "Publishing uses the authorised site connection. The destination and scope are shown before release.",
  "guidedBody": "This site has no supported automatic deployment connection. See the installation guide in Airlock; automatic publishing is not available here.",
  "deployBoundary": "Viewing this page does not generate content, deploy, or call a model.",
  "unavailable": "The selected website is unavailable. Choose from the website list; no other site has been selected for you.",
  "connect": "Connect an existing website",
  "create": "Create a new website",
  "emptyBody": "Set up a website before enabling Airlock. A publishing destination will not be guessed.",
  "connectHelp": "Connecting requires the website address, management permission and a supported connection. Self-service setup is not available yet; ask your project owner to configure the site first.",
  "createHelp": "A new site needs confirmed content and a hosting address. Self-service creation is not available yet; configured sites will appear in this list.",
  "tabs": {
    "overview": "Overview",
    "pages": "Pages & publishing",
    "airlock": "Airlock",
    "deploy": "Domain & deployment"
  },
  "environment": {
    "production": "Production",
    "staging": "Test environment"
  },
  "airlockState": {
    "preparing": "Preparing",
    "ready": "Ready",
    "publishing": "Publishing",
    "live": "Live",
    "paused": "Paused",
    "failed": "Needs attention"
  },
  "slot": {
    "widget": "Floating assistant",
    "inline": "Inline assistant",
    "focus": "Focused assistant"
  }
},
  material: {
  "pending_domain": "Material received, awaiting scope confirmation. It is not in reception knowledge yet.",
  "awaiting_knowledge_confirmation": "Material is classified public. Knowledge still needs preparation and confirmation; it has not been synced.",
  "private_only": "This material is private and cannot support public answers. Add public material or set an answer boundary.",
  "synced": "The approved material is now in this project's Airlock knowledge. Return to Airlock to test it again.",
  "loadError": "Material progress could not be loaded. This does not mean your submission is missing. Reopen this page shortly.",
  "addMore": "Add more material"
},
  workspace: {
    loading: 'Loading authorised sites…', error: 'The latest site state could not be loaded.', empty: 'No authorised site or verified publication is available yet.', authorisedSites: 'authorised site workspaces', verifiedRoutes: 'verified live routes', preservedIssues: 'issues preserved for action', eyebrow: 'Site workspaces', title: 'Every live destination and its latest verified release', siteCount: '{count} site(s)', mode: 'Site mode', managedStatic: 'Navigator-managed static site', languages: 'Supported languages', lastDeploy: 'Latest release', machine: 'Machine layer', noRelease: 'No Action release has been recorded for this site yet.',
    status: { configured: 'Configured', building: 'Building', ready: 'Ready', deploying: 'Deploying', state_unknown: 'State needs verification', live: 'Live', failed: 'Needs attention' }, machineStatus: { pending: 'Preparing', verified: 'Verified', unknown: 'Unknown · fail closed', failed: 'Failed' },
  },
} as const

export default presence
